var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClassroom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_11465",
    "data-name": "Grupo 11465",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.92,
    height: 18.924,
    viewBox: "0 0 25.92 18.924",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_29",
    "data-name": "Trazado 29",
    d: "M133.664,68.084a4.555,4.555,0,1,0,4.552,4.555,4.553,4.553,0,0,0-4.552-4.555",
    transform: "translate(-120.704 -63.179)",
    fill: "#64c5dd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_30",
    "data-name": "Trazado 30",
    d: "M131.722,67.668a1.051,1.051,0,0,1,.024,1.486,7.042,7.042,0,0,0,0,9.749,1.051,1.051,0,0,1-1.507,1.465,9.142,9.142,0,0,1,0-12.68,1.047,1.047,0,0,1,1.483-.021m9.434,0a1.051,1.051,0,0,1,1.486.021,9.148,9.148,0,0,1,0,12.68,1.051,1.051,0,1,1-1.507-1.465,7.042,7.042,0,0,0,0-9.749,1.051,1.051,0,0,1,.021-1.486",
    transform: "translate(-123.48 -64.566)",
    fill: "#64c5dd",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31",
    "data-name": "Trazado 31",
    d: "M131.537,66.726a1.053,1.053,0,0,1,0,1.486,10.829,10.829,0,0,0,0,15.332,1.052,1.052,0,1,1-1.486,1.489,12.934,12.934,0,0,1,0-18.307,1.048,1.048,0,0,1,1.486,0m15.355,0a1.048,1.048,0,0,1,1.486,0,12.934,12.934,0,0,1,0,18.307,1.052,1.052,0,1,1-1.486-1.489,10.829,10.829,0,0,0,0-15.332,1.053,1.053,0,0,1,0-1.486",
    transform: "translate(-126.255 -66.417)",
    fill: "#64c5dd",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassroom);
export default __webpack_public_path__ + "static/media/classroom.8717627fde50086e45c9de3bf89c3eca.svg";
export { ForwardRef as ReactComponent };